import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../product/components/atoms/SecondaryButton'
import FullScreenPopup from '../../product/components/organisms/FullScreenPopup'
import UserContext from '../../product/context/user/userContext'
import CustomCommonContext from '../../custom/context/common/commonContext'
import { Button } from '@mui/material'
import { LinearProgress } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Country as CSCCountry, State as CSCState } from 'country-state-city'
import moment from 'moment'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../product/common/components'
import { dateFormatFrontOnlyDate } from '../../custom/common/components'
import './UserManage.css'
import Loaders from '../../product/components/molecules/Loaders'
import CyberSourceCardContext from '../../product/context/userThirdParty/payment/cybersource/card/cardContext'

const UserManage = (props) => {
    const userContext = useContext(UserContext)
    const customCommonContext = useContext(CustomCommonContext)

    const {
        get_all_card_details,
        getAllCards,
        responseStatus: responseStatusCard,
        clearResponse: clearResponseCard,
    } = useContext(CyberSourceCardContext)

    const {
        single_user,
        getSingleUser,
        userAction,
        responseStatus: responseStatusUser,
    } = userContext

    const [isLoading, setIsLoading] = useState(false)
    const [cards, setCards] = useState([])

    const data = props.data
    const toggleFullScreenPopup = props.function

    const t = (text) => {
        text = text.charAt(0).toUpperCase() + text.slice(1)
        return text.replace(/_/g, ' ')
    }

    const validationArray = Yup.object({
        first_name: Yup.string()
            .min(2, 'Minimum 2 characters')
            .max(250, 'Maximum 250 characters')
            .required('Required!'),
        last_name: Yup.string()
            .min(2, 'Minimum 2 characters')
            .max(250, 'Maximum 250 characters')
            .required('Required!'),
        address1: Yup.string()
            .trim()
            .matches(
                /^[0-9a-zA-Z- ,.#()]*$/g,
                'Some kind of special characters not allowed'
            )
            .max(250, 'Maximum 250 Character')
            .required('Required!'),
        address2: Yup.string()
            .trim()
            .matches(
                /^[0-9a-zA-Z- ,.#()]*$/g,
                'Some kind of special characters not allowed'
            )
            .max(250, 'Maximum 250 Character'),
        email: Yup.string()
            .email('Invalid email format')
            .max(250, 'Maximum 250 characters')
            .required('Required'),
        confirm_email: Yup.string()
            .email('Invalid email format')
            .test('equal', 'emails_do_not_match', (item) =>
                item
                    ? item.toLowerCase() === formik.values.email.toLowerCase()
                    : true
            )
            .required('Required'),
        phone: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required!'),
        country: Yup.string().trim().required('Required!'),
        city: Yup.string().required('Required!'),
        state: Yup.string().trim().required('Required!'),
        zip: Yup.string()
            .trim()
            .matches(/^[0-9]*$/g, 'The positive numeber only')
            .max(6, 'maximum 6 characters')
            .min(3, 'minimum 3 characters')
            .required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            email: '',
            confirm_email: '',
            first_name: '',
            last_name: '',
            address1: '',
            address2: '',
            phone: '',
            city: '',
            country: global.defaultCountry,
            state: '',
            zip: '',
            companyname: '',
            cybersource_id: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            const value = values
            userAction(value)
        },
    })
    useEffect(() => {
        setIsLoading(false)
    }, [])
    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    }, [])
    useEffect(() => {
        if (data.status === 'card') {
            setIsLoading(true)
            formik.values.id = data.id
            getSingleUser(formik.values)
        } else {
            resetFrom()
        }
    }, [data])

    const getCyberSourceCards = () => {
        getAllCards({
            user_id: data.id,
            customer_id: formik.values.cybersource_id,
            object: 'card',
        })
    }

    useEffect(() => {
        if (formik.values.cybersource_id) {
            getCyberSourceCards()
        } else {
            setCards([])
        }
    }, [formik.values.cybersource_id])

    useEffect(() => {
        if (
            get_all_card_details &&
            get_all_card_details.records.length
            // search_singlecart?.cartvalues?.total_amount <= configVariables?.stripe_ach_limit
        ) {
            setCards(get_all_card_details.records)
        } else {
            setCards([])
        }

        return () => {
            setCards([])
        }
    }, [get_all_card_details])

    useEffect(() => {
        if (single_user.record && data.status === 'card') {
            const user = single_user.record
            console.log('user', user)
            formik.setValues({
                // Here We Iniatalize the fields to show orignal data
                id: user.id,
                first_name: user.first_name,
                last_name: user.last_name,
                // passport_number: user.passport_number,
                // emirates_id: user.emirates_id ? user.emirates_id : '',
                companyname: user.companyname,
                phone: user.phone,
                email: user.email,
                confirm_email: user.email,
                state: user.state,
                city: user.city,
                address1: user.address1,
                address2: user.address2,
                zip: user.zip,
                country: user.country,
                cybersource_id: user.cybersource_id,
            })
        } else {
            resetFrom()
        }
        setIsLoading(false)
    }, [single_user])

    useEffect(() => {
        const user = single_user?.record
        if (user && user.country && formik.values.country === user.country) {
            formik.setFieldValue('state', user.state)
        } else {
            formik.setFieldValue('state', '')
        }
    }, [formik.values.country])

    const resetFrom = () => {
        formik.values.email = ''
        formik.values.address1 = ''
        formik.values.address2 = ''
        formik.values.city = ''
        formik.values.first_name = ''
        formik.values.last_name = ''
        formik.values.phone = ''
        formik.values.state = ''
        formik.values.zip = ''
        formik.values.country = global.defaultCountry
        formik.handleReset()
        setIsLoading(false)
    }

    const IndividualRegistration = {
        formik: formik,
        data: [
            {
                label: t('first_name') + '*',
                name: 'first_name',
                type: 'text',
                placeholder: t('enter_your_first_name'),
                class: 'col-12 col-sm-6',
                autoFocus: true,
                disabled: true,
            },
            {
                label: t('last_name') + '*',
                name: 'last_name',
                type: 'text',
                placeholder: t('enter_your_last_name'),
                class: 'col-12 col-sm-6',
                disabled: true,
            },
            {
                label: 'Company ' + '*',
                name: 'companyname',
                type: 'text',
                placeholder: 'Enter your company name',
                class: 'col-12 col-sm-6',
                disabled: true,
            },
            {
                label: t('email_address') + '*',
                name: 'email',
                type: 'email',
                placeholder: t('enter_your_email_address'),
                class: 'col-12 col-sm-6',
                disabled: true,
            },
        ],
    }

    IndividualRegistration.data.push({
        label: 'Customer ID' + '*',
        name: 'cybersource_id',
        type: 'text',
        placeholder: 'Customer ID',
        class: 'col-12 col-sm-6',
        disabled: true,
    })

    const formSubmit = (e) => {
        formik.handleSubmit(e)
        console.log(formik.errors)
    }

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from === 'userAction') {
                formik.setSubmitting(false)
                setIsLoading(false)
            }
        }
    }, [responseStatusUser])

    return (
        <FullScreenPopup
            modaltitle={data.status === 'card' ? 'VIEW CARD' : ''}
            open={data.status === 'card' ? data.popup : false}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    {formik.isSubmitting ? <LinearProgress /> : null}
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <form onSubmit={formSubmit} autoComplete="nofill">
                            <div>
                                <div className="row">
                                    {mapData(IndividualRegistration)}
                                </div>
                            </div>
                            <div className="savedCards">
                                {cards &&
                                    cards.map((data, index) => (
                                        <div
                                            className="savedCardsCard"
                                            key={index}
                                        >
                                            {console.log('data', data)}
                                            <h4> Card ID: {data.id}</h4>
                                            {/* <h4> Instrument ID: {data.instrumentIdentifier.id}</h4> */}
                                            <h4>
                                                EXP.&nbsp;&nbsp;&nbsp;&nbsp;
                                                {data.card.expirationMonth +
                                                    ' / ' +
                                                    data.card.expirationYear}
                                            </h4>
                                            <h3>
                                                {
                                                    data._embedded
                                                        .instrumentIdentifier
                                                        .card.number
                                                }
                                            </h3>
                                            {data.default && (
                                                <h6 className="defaultSelection">
                                                    Default
                                                </h6>
                                            )}
                                        </div>
                                    ))}
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default UserManage
